module.exports = __webpack_public_path__ + "static/img/co-operate-02.7c38b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-02.png
// module id = KPnR
// module chunks = 1